<main class="main dashboard-wrapper d-flex flex-column flex-lg-row">
    <section class="dashboard-left flex-column d-none d-lg-flex col-lg-6">
        <div class="dashboard-left-content">
            <img
                src="../../../assets/images/AuPair-Logo-white.svg"
                alt="AuPair-Logo-white"
                width="160"
                height="50.95" />
        </div>
    </section>
    <section class="dashboard-right d-flex flex-column col-12 col-lg-6 position-relative">
        <div class="dashboard-right-content">
            <header></header>
        </div>
        <div>
            <app-tax-years-list></app-tax-years-list>
        </div>
        <app-session-expires *ngIf="!contentService.isMobile"></app-session-expires>
        <app-footer *ngIf="!contentService.isMobile"></app-footer>
    </section>
    <app-session-expires *ngIf="contentService.isMobile"></app-session-expires>
    <app-footer *ngIf="contentService.isMobile"></app-footer>
</main>
